var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item)?_c('iframe',{staticClass:"demos__iframe w-100",style:({ height: _vm.height + 'px' }),attrs:{"src":_vm.demoUrl,"frameborder":"0","allowfullscreen":"allowfullscreen"},on:{"load":_vm.onIframeLoaded}}):_vm._t("fallback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }